import api from '@/api/API';
import isGranted from '@/auth/isGranted';
import {
  Client, ClientFilters, ClientSummary,
  ClientSummaryFilters, QueryResult,
} from '@/types';

export default {
  find(id: string): Promise<Client> {
    return api
      .get(`clients/${id}`)
      .then(response => response.data);
  },
  findAll(filters: ClientFilters): Promise<QueryResult> {
    if (!isGranted('FIND_CLIENTS')) return Promise.reject();
    return api
      .get('clients', { params: filters })
      .then(response => response.data);
  },
  findSummary(id: string, filters: ClientSummaryFilters): Promise<ClientSummary> {
    return api
      .get(`clients/${id}/summary`, {
        params: filters,
      })
      .then(response => response.data);
  },
  findUnsubscribed(userId: string, keyword: string|null): Promise<Client[]> {
    return api
      .get(`users/${userId}/unsubscribed-clients`, { params: { userId, keyword } })
      .then(response => response.data);
  },
};
